import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface RHFFormsState {
  [formName: string]: Record<string, unknown>;
}

const initialState: RHFFormsState = {};

const rhfFormsSlice = createSlice({
  name: 'rhfForms',
  initialState,
  reducers: {
    setFormValues(
      state,
      action: PayloadAction<{ formName: string; values: Record<string, unknown> }>,
    ) {
      state[action.payload.formName] = action.payload.values;
    },
    clearForm(state, action: PayloadAction<string>) {
      delete state[action.payload];
    },
    clearAllForms() {
      return initialState;
    },
  },
});

export const { setFormValues, clearForm, clearAllForms } = rhfFormsSlice.actions;
export default rhfFormsSlice.reducer;
